import { Box, Table, TableBody, TableContainer } from "@material-ui/core";
import CssPagination from "src/components/Pagination/CssPagination";
import Empty from "src/components/utils/Empty";
import usePagination from "src/hooks/usePagination";
import useSortData from "src/hooks/useSortData";
import { getFavoriteTokens } from "src/services/favoriteToken";
import RankingHeader from "./RankingHeader";
import RankingRow from "./RankingRow";

export default function RankingTable({ tokens }) {
  const favoriteToken = getFavoriteTokens();

  const { update, data: sortData, sortType, sortKey } = useSortData(tokens, "desc", "credit_score");
  const len = sortData.length;
  const { data, jump, maxPage, currentPage } = usePagination(sortData);

  return (
    <>
      <TableContainer>
        <Table>
          <RankingHeader sortUpdate={update} sortType={sortType} sortKey={sortKey} />
          <TableBody>
            {data.map((rowData, index) => {
              if (favoriteToken.includes(rowData.token_id)) rowData["isFavorite"] = true;
              else rowData["isFavorite"] = false;
              return <RankingRow key={index} rowData={rowData} />;
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {len === 0 && (
        <Box textAlign="center" pt={3}>
          <Empty title="No Data" iconProps={{ style: { fontSize: "60px" } }} />
        </Box>
      )}
      {len > 0 && (
        <CssPagination
          mt={1}
          paginationProps={{ page: currentPage, count: maxPage, onChange: (_, page) => jump(page) }}
        />
      )}
    </>
  );
}
